export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    const body = $('body');

    const hotelRoomSubmit = $('.hotel-room-submit');
    if (hotelRoomSubmit.length) {
      hotelRoomSubmit.each(function() {
        const _this = $(this);

        _this.on('click', function(e) {
          e.preventDefault();

          if( window.innerWidth >= 992 ) {
            // desktop
            $('.booking-daterange-picker').first().data('daterangepicker').show();
          } else if ( window.innerWidth < 992 ) {
            // Mobile
            $('.hotel-mobile-booking-modal').addClass('show');
            body.addClass('modal-open');
          }
        });
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCptRoom.js